import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';
import { formatHeat } from '@/utils/movie';

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie-detail/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-900 border border-background-800 hover:border-primary-500/60 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-800">
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          title={`${movie.title} 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/20 to-transparent"></div>

        <div className="absolute top-3 left-3 flex items-center gap-1 px-2 py-1 rounded-md bg-background-950/70 backdrop-blur-sm">
          <i className="ri-star-fill text-primary-400 text-xs"></i>
          <span className="text-xs font-semibold text-foreground-100">{movie.rating.toFixed(1)}</span>
        </div>

        <div className="absolute top-3 right-3 px-2 py-1 rounded-md bg-background-950/70 backdrop-blur-sm text-xs text-foreground-200">
          {movie.year}
        </div>

        <div className="absolute inset-0 flex flex-col justify-end p-4 bg-background-950/85 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <p className="text-xs text-foreground-200 leading-relaxed line-clamp-5">{movie.summary}</p>
          <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-400">
            <i className="ri-play-circle-line"></i>
            查看详情
          </span>
        </div>
      </div>

      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-50 truncate group-hover:text-primary-400 transition-colors">
          {movie.title}
        </h3>
        <div className="mt-2 flex items-center justify-between gap-2">
          <div className="flex items-center gap-1.5 flex-wrap">
            {movie.types.slice(0, 2).map((type) => (
              <span key={type} className="px-2 py-0.5 rounded-full text-[11px] bg-secondary-500/15 text-secondary-300">
                {type}
              </span>
            ))}
          </div>
          <span className="flex items-center gap-1 text-[11px] text-foreground-400 whitespace-nowrap">
            <i className="ri-fire-line text-accent-400"></i>
            {formatHeat(movie.heat)}
          </span>
        </div>
      </div>
    </Link>
  );
}